import { FilterDto, FilterType } from '../../../types/FilterDto';
import type { TFunction } from 'i18next';
import { SelectItemDto } from '../../../types/SelectItemDto';
import { getRequestTypesByClient } from '../../admin/claimRequestType/api/claimRequestTypeApi';
import { getTopicFilter } from '../../topics/api/getTopics';

export const getFiltersImprovementPlansDemands = async  (
    t: TFunction<[string], undefined>,
    assignedToOptions: SelectItemDto[]
): Promise<FilterDto[]> => {
    const claimRequestTypes = await getRequestTypesByClient();
    const topicFilter: FilterDto = await getTopicFilter();
    topicFilter.description = t(topicFilter.description);

    const staticFilters: FilterDto[] = [
        {
            name: 'UserId',
            description: t('improvementPlan:demandsModal.filterAssignedTo'),
            type: FilterType.SELECT,
            values: (assignedToOptions ?? []).map(option => ({
                key: option.id.toString(),
                value: option.name
            }))
        },
        {
            name: 'RequestTypeId',
            description: t('improvementPlan:demandsModal.filterClaimType'),
            type: FilterType.SELECT,
            values: (claimRequestTypes ?? []).map(option => ({
                key: option.id.toString(),
                value: option.name
            }))
        }
    ];

    return [...staticFilters, topicFilter];
};